import { useState, useCallback, useEffect } from 'react';
import GridAtom from '@components/atom/grid/grid';
import { teamManagerViewType } from '@models/manager/account/account';
import { TeamMember } from '@classes/options/grid/account/teamGridOption';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { setViewState } from '@reducers/account/teamSlice';

const MemberList = ({ filterObj }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { memberInfoList } = useSelector(({ team }: RootState) => team);
  const [gridChartOption, setGridChartOption] = useState(null);

  const _option = new TeamMember();

  // memberList 바뀔때 처리
  useEffect(() => {
    if (memberInfoList) {
      setGridChartOption(_option.memberList(memberInfoList));
    }
  }, [memberInfoList]);

  // filterObj 바뀔때 처리
  useEffect(() => {
    if (memberInfoList) {
      if (filterObj) {
        setGridChartOption(_option.memberList(memberInfoList, filterObj));
      }
    }
  }, [filterObj]);

  const onClickBackToList = useCallback(() => {
    dispatch(setViewState({ view: teamManagerViewType.teamList }));
  }, [dispatch, setViewState]);

  return (
    <>
      <GridAtom {...gridChartOption} height={'450px'} />
      <button type="button" className="btn pri" onClick={onClickBackToList}>
        Back to TeamList
      </button>
    </>
  );
};

export default MemberList;
